import { getProperty } from "./utils/FPEUtils";

let settings;
export const getCustomerSettings = (key) => {
  return getProperty(settings, key);
}

export const setCustomerSettings = param => {
  settings = param
}
